import { Entity, IEntity } from "./Entity";
import { IPPVisionObjective } from "./PPVisionObjective";

export interface IPPVision extends IEntity {
    Description?: string
    CurrentVision?: boolean;
    CustomerID: number | null;
    PPVisionObjectives?: IPPVisionObjective[];
}

export class PPVision extends Entity implements IPPVision {
    public Description = null;
    public CurrentVision = null;
    public CustomerID = null;
}